module.exports = __webpack_public_path__ + "img/keder_verkehrsgelb_ral1023.7fece32a.jpg";